var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddList = function SvgAddList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.188 2.83591H3.52132V13.5026H12.8547V5.50258H10.188V2.83591ZM2.18799 2.16391C2.18799 1.79858 2.48599 1.50258 2.85399 1.50258H10.8547L14.188 4.83591V14.1646C14.1886 14.2521 14.172 14.3389 14.139 14.4201C14.1061 14.5012 14.0575 14.575 13.996 14.6374C13.9346 14.6997 13.8614 14.7493 13.7808 14.7834C13.7001 14.8175 13.6135 14.8353 13.526 14.8359H2.84999C2.67491 14.8347 2.50733 14.7646 2.38347 14.6409C2.2596 14.5172 2.18938 14.3497 2.18799 14.1746V2.16391ZM7.52132 7.50258V5.50258H8.85465V7.50258H10.8547V8.83591H8.85465V10.8359H7.52132V8.83591H5.52132V7.50258H7.52132Z"
  })));
};
export default SvgAddList;